import { Flex } from "antd";
import { useState } from "react";

import { UniversalTabs } from "@/shared/ui/UniversalTabs";

import { SelectedDateSalaryState } from "../hooks/useSelectedDateSalary";
import Payments from "./Payments";
import Sales from "./Sales";
import { SelfPlan } from "./SelfPlan";

type TabValue = "personal-plan" | "sales" | "payments";

const tabsConfig: { value: TabValue; label: string }[] = [
    { value: "personal-plan", label: "Персональний план" },
    { value: "sales", label: "Продажі" },
    { value: "payments", label: "Оплати" },
];

export interface DashboardTabsProps {
    routeId: string;
    employeeId: string;
    onSalaryDataChange?: (selectedDateSalary: SelectedDateSalaryState) => void;
}

export const DashboardTabs = ({
    routeId,
    employeeId,
    onSalaryDataChange,
}: DashboardTabsProps) => {
    const [currentTab, setCurrentTab] = useState<TabValue>("personal-plan");

    const renderTabContent = (tab: TabValue) => {
        switch (tab) {
            case "personal-plan":
                return (
                    <SelfPlan
                        source="work"
                        employeeId={employeeId}
                        onSalaryDataChange={onSalaryDataChange}
                    />
                );
            case "sales":
                return <Sales routeId={routeId} />;
            case "payments":
                return <Payments routeId={routeId} employeeId={employeeId} />;
            default:
                return null;
        }
    };

    return (
        <Flex
            vertical
            gap="16px"
            flex={1}
            style={{ position: "relative", minHeight: 0, width: "100%" }}
        >
            <UniversalTabs
                value={currentTab}
                onChange={(val: TabValue) => setCurrentTab(val)}
                tabs={tabsConfig}
                maxWidth="340px"
            />

            {renderTabContent(currentTab)}
        </Flex>
    );
};
